// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3dxl_","dragIcon":"SortableItem_dragIcon__jf-8z","disabled":"SortableItem_disabled__2nc4G"};